module.exports = __webpack_public_path__ + "static/media/CSS_style.0dc032b5.webp";